import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Billing PC shortcuts (owner, 2026-10-24):
 *   Ctrl+S  Sale summary
 *   Ctrl+I  Item sales
 *   Ctrl+O  Orders / KOT history
 *   Ctrl+T  Billing tables
 * They replace the browser's own Save / Page info / Open file on these keys,
 * which nobody at the till wants. The screen opened still decides who may see it.
 * Ctrl+T works in the RestoYaar till app; a plain Chrome window keeps Ctrl+T
 * for "new tab" and never hands it to the page.
 */
export const REPORT_SHORTCUTS = {
  s: "/reports?tab=sale-summary",
  i: "/reports?tab=item-sales",
  o: "/orders/history",
  t: "/billing",
};

export function shortcutTarget(event) {
  if (!(event.ctrlKey || event.metaKey) || event.altKey || event.shiftKey) return null;
  return REPORT_SHORTCUTS[String(event.key || "").toLowerCase()] || null;
}

/**
 * Whether leaving the screen now could lose work: an open dialog (a settle in
 * progress), a table being billed (its unsent cart lives only on this screen,
 * and that screen has its own keys: F8/Esc), or the cursor in a form field
 * (Ctrl+S there is a reflex for "save", not "go to reports").
 */
export function busyHere(pathname = window.location.pathname) {
  if (document.querySelector('[role="dialog"], [role="alertdialog"]')) return true;
  if (/^\/billing\/table\//.test(pathname)) return true;
  const el = document.activeElement;
  return Boolean(el && (el.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName)));
}

export function useReportShortcuts() {
  const navigate = useNavigate();
  useEffect(() => {
    const onKey = event => {
      const to = shortcutTarget(event);
      if (!to || busyHere()) return;
      event.preventDefault();
      navigate(to);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate]);
}
